export const update = {
  form: {
    price: '価格/円',
    quantity: '仕入れ数量',
    name: '商品名(洗剤名)',
    submit: '新規追加',
    requirePrice: '価格/円を入力してください',
    requireQuantity: '仕入れ数量を入力してください',
    update: '保存',
    priceUnit: '円',
    quantityUnit: 'グラム',
    cancel: 'キャンセル',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '在庫履歴　情報編集画面',
    back: '戻る',
  },
}
